import fs from 'react-native-fs';
import Const from 'consts/Const';
import Funcs from './Funcs';
import Time from './Time';

export default {
  moveImageFile: async (uri, imageType, objectId = '0', type = 'product') => {
    let icon = '';
    if (uri && imageType) {
      imageType = imageType.split('/');
      imageType = imageType[imageType.length - 1];
      try {
        let targetDir = Const.imagePath;
        let isExist = await fs.exists(targetDir);
        if (!isExist) await fs.mkdir(targetDir);
        icon = `${type}_${Time.format(new Date(), 'YYYY-MM-DD')}_${objectId + 1000}_${Math.floor(Date.now() / 1000)}.${imageType}`;
        targetDir = `${targetDir}${icon}`;
        uri = decodeURIComponent(uri);
        targetDir = decodeURIComponent(targetDir);
        await fs.moveFile(uri, targetDir);
      } catch (err) {
        Funcs.log(err);
        return;
      }
    }
    return icon;
  },

  deleteFile: async (path) => {
    try {
      let check = await fs.exists(path);
      if (check) await fs.unlink(path);
      Funcs.log('Remove file', path);
    } catch (err) {
      Funcs.log(err);
    }
  },

  cleanTmpImages: async () => {
    try {
      const tmpDir = fs.TemporaryDirectoryPath;
      const files = await fs.readDir(tmpDir);

      for (const file of files) {
        // Lọc chỉ các file ảnh theo đuôi phổ biến
        if (file.isFile() && /\.(png|jpe?g|webp)$/i.test(file.name)) {
          try {
            await fs.unlink(file.path);
          } catch (e) {
            // Bỏ qua nếu file đang bị lock hoặc không tồn tại
          }
        }
      }

      Funcs.log('Clean tmp image files');
    } catch (err) {
      Funcs.warn('Error clean tmp:', err);
    }
  }
};
